import {createSlice} from '@reduxjs/toolkit'

import validateDiscount from '../thunks/validateDiscount'
import fetchOrder from '../thunks/fetchOrder'

const initialState = {
  // Data fetched from and submitted to server
  data: {
    discounts: null,
    giftCards: []
  },
  // Status, message, and error
  status: '',
  discountsMessage: null,
  error: null,
  // Local state
  discountCode: '',
  displayDiscountsMessage: false
}

const discountsSlice = createSlice({
  name: 'discounts',
  initialState,
  reducers: {
    removeDiscount(state, action) {
      state.data.discount_code = null
      state.discountsMessage = `Removed discount code ${action.payload}`
      state.displayDiscountsMessage = true
    },
    removeGiftCard(state, action) {
      state.data.giftCards = state.data.giftCards.filter(({gift_card_code}) => gift_card_code !== action.payload)
      state.discountsMessage = `Removed gift card ${action.payload}`
      state.displayDiscountsMessage = true
    },
    setDiscountCode(state, action) {
      state.discountCode = action.payload
      state.displayDiscountsMessage = false
    },
    setDisplayDiscountsMessage(state, action) {
      state.displayDiscountsMessage = action.payload
    },
    changeDiscountsStatus (state, action) {
      state.status = action.payload
    }
  },
  extraReducers: {
    // Set discount code from order
    [fetchOrder.fulfilled]: (state, action) => {
      if(action.payload.discount_code) {
        state.data.discount_code = action.payload.discount_code
      }
    },
    // validate_cart_discount
    [validateDiscount.pending]: (state) => {
      state.status = 'loading'
    },
    [validateDiscount.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.discountsMessage = action.payload.message

      state.discountCode = ''
          
      if(action.payload.message) {
        state.displayDiscountsMessage = true
      }

      if(action.payload.discount_code) {
        state.data.discount_code = action.payload.discount_code
      }

      if(action.payload.gift_card && typeof state.data.giftCards.find(({gift_card_code}) => gift_card_code === action.payload.gift_card.gift_card_code) === 'undefined') {
        state.data.giftCards.push(action.payload.gift_card)
      }
    },
    [validateDiscount.rejected]: (state, action) => {
      state.status = 'failed'
      if(action.payload) {
        state.error = action.payload.message
      } else {
        state.error = action.error.message
      }
    }
  }
})

export default discountsSlice.reducer

export const {
    removeDiscount,
    removeGiftCard,
    setDiscountCode,
    setDisplayDiscountsMessage,
    changeDiscountsStatus
  } = discountsSlice.actions


// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/slices/discountsSlice.js